export default __webpack_public_path__ + "static/media/207.4a4424c2.jpg";